import { SupabaseClient } from "@supabase/supabase-js";
import { USERS_TABLE_NAME } from "../../constants";
import { MartianUser } from "../../modules/user/types";

// Create a new user
// TODO
export async function updateMartianUser(sb: SupabaseClient, userId: string, walletAddress: string, hasCustodialWallet: boolean) : Promise<boolean> {
    const { data, error } = await sb
        .from(USERS_TABLE_NAME)
        .update({
            wallet_address: walletAddress,
            has_custodial_wallet: hasCustodialWallet
        })
        .eq('id', userId); // Match the user record by the unique 'id' column

    console.log("Update User Data:", data);
    console.log("Update User Error:", error);

    if(error) {
        // Handle the error appropriately
        console.error("Error updating user:", error);
        return false; // Return false to indicate the update was unsuccessful
    }

    return true; // Return true to indicate the update was successful
}


// Get single user for martian from user id
export async function getMartianUser(sb: SupabaseClient, userId: string) : Promise<MartianUser> {
    let {data, error} = await sb
        .from(USERS_TABLE_NAME)
        .select(
            `id, first_name, last_name, avatar_url, website, has_setup, email, martian_name, has_custodial_wallet, email, wallet_address`
        )
        .eq('id', userId)
        .single();

        console.log("Fetched User Data:", data);
        console.log("Fetch Error:", error);

    if(error != null || data == null) {
            console.log(error)
            throw Error('Unable to fetch user data')
    }

    const user: MartianUser = {
        id: data.id,
        martianName: data.martian_name,
        avatarUrl: data.avatar_url,
        hasSetup: data.has_setup,
        hasCustodialWallet: data.has_custodial_wallet,
        walletAddress: data.wallet_address,
        email: data.email,
        firstName: data.first_name,
        lastName: data.last_name
    };
    console.log("MartianUser Object:", user);
    return user
}

// Get martian user by name
export async function getMartianUserByName(sb: SupabaseClient, martianName: string) : Promise<MartianUser> {
    let {data, error} = await sb
        .from(USERS_TABLE_NAME)
        .select(
            `id, firt_name, last_name, avatar_url, website, has_setup, email, martian_name`
        )
        .eq('martian_name', martianName)
        .single();

    if(error != null || data == null) 
            throw Error('Unable to fetch user data')

    const user: MartianUser = {
        id: data.id,
        martianName: data.martian_name,
        avatarUrl: data.avatar_url,
        hasSetup: data.has_setup,
        hasCustodialWallet: undefined
    };
    return user
}